import { render, staticRenderFns } from "./GreenCard.vue?vue&type=template&id=d112e6a4&scoped=true&"
import script from "./GreenCard.vue?vue&type=script&lang=ts&"
export * from "./GreenCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d112e6a4",
  null
  
)

export default component.exports